import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconButtonWithTooltip } from '../IconButtonWithTooltip';
import { BaseActionProps } from '../types';

export const Clone: React.FC<BaseActionProps> = (props) => {
  const { t } = useTranslation();

  return (
    <IconButtonWithTooltip
      tooltip={props.disabled ? t('RIGHTS.MISSING') : t('COMMON.CLONE')}
      icon={<ContentCopyIcon style={{ width: '1.5rem', height: '1.5rem' }} />}
      {...props}
    />
  );
};
